// page src/services/subscriptionService.ts
import apiService from './api'

import type { SubscriptionPlan, PaymentResponse } from '../types/payment'

export const subscriptionService = {
  async getPlans(userId?: string): Promise<SubscriptionPlan[]> {
    const query = userId ? `?user_id=${encodeURIComponent(userId)}` : '';
    return apiService.get<SubscriptionPlan[]>(`/subscription/plans${query}`);
  },
  async getPlanTypes(): Promise<any[]> {
    return apiService.get<any[]>('/subscription/plan-types');
  },
  async getMySubscription (userId: string) {
    return apiService.get(`/subscription/me/${userId}`)
  },
  async getCurrentSubscription(): Promise<any> {
    return apiService.get('/subscriptions/current');
  },

  // async checkout (userId: string, planId: string): Promise<PaymentResponse> {
  //   return apiService.post<PaymentResponse>('/subscription/checkout', {
  //     user_id: userId,
  //     plan_id: planId
  //   })
  // }
  async checkout (
    userId: string,
    planId: string,
    planTypeId?: number,
    couponCode?: string
  ): Promise<PaymentResponse> {

    return apiService.post(
      "/subscription/checkout",
      {
        user_id: userId,
        plan_id: planId,
        plan_type_id: planTypeId || null,
        coupon_code: couponCode || null,
      }
    );
  },
  async getInvoices (userId: string) {
    return apiService.get(`/subscription/invoices/${userId}`)
  },
  async getBillingHistory(userId: string, page: number = 1, pageSize: number = 5): Promise<{ items: any[]; total: number; page: number; page_size: number }> {
    return apiService.get(`/subscription/billing-history/${userId}?page=${page}&page_size=${pageSize}`);
  },
  async downloadInvoiceUrl (invoiceId: string, invoiceNumber?: string) {
    // Return the absolute API endpoint URL for file download to open directly or download via link
    const token = localStorage.getItem('access_token') || localStorage.getItem('token') || '';
    const baseUrl = import.meta.env.VITE_API_BASE_URL || '/api/v1';
    const suffix = invoiceNumber ? `/${invoiceNumber}.pdf` : '';
    return `${baseUrl}/subscription/invoices/${invoiceId}/download${suffix}?token=${token}`;
  }
}

